import { CtrlType } from '@yuigoto/ctrl';

export const CampaignControl = [
  [
    {
      name: 'title',
      alias: 'title',
      required: true,
      requiredMessage: 'Preencher o nome é obrigatório',
      label: 'Marca',
      wrapClass: 'col-12 col-sm-12 col-md-4',
    },
    {
      name: 'statusName',
      alias: 'statusName',
      type: CtrlType.HIDDEN,
    },
    {
      name: 'statusId',
      alias: 'status',
      label: 'Status',
      wrapClass: 'col-12 col-sm-12 col-md-4',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
      type: CtrlType.DATALIST,
      options: [],
    },
    {
      name: 'project',
      label: 'Código do Projeto',
      wrapClass: 'col-12 col-sm-12 col-md-4',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
    },
  ],
  [
    {
      name: 'dateFrom',
      required: true,
      requiredMessage: 'Preencher a data é obrigatório',
      placeholder: 'DD/MM/AAAA',
      label: 'Data início (gp)',
      wrapClass: 'col-12 col-sm-12 col-md-3',
      type: CtrlType.DATE,
    },
    {
      name: 'dateTo',
      placeholder: 'DD/MM/AAAA',
      required: true,
      requiredMessage: 'Preencher a data é obrigatório',
      label: 'Data fim (gp)',
      type: CtrlType.DATE,
      wrapClass: 'col-12 col-sm-12 col-md-3',
    },
    {
      name: 'members',
      label: 'Qtd de GPs',
      wrapClass: 'col-12 col-sm-12 col-md-3',
      type: CtrlType.NUMBER,
    },
    {
      name: 'finishDate',
      label: 'Data finalização',
      placeholder: 'DD/MM/AAAA',
      type: CtrlType.DATE,
      wrapClass: 'col-12 col-sm-12 col-md-3',
    },
  ],
  [
    {
      name: 'influencerPaymentTypeId',
      alias: 'paymentTypeId',
      label: 'Modalidade de postagem',
      wrapClass: 'col-12 col-sm-12 col-md-6',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
      type: CtrlType.DATALIST,
      options: [],
    },
    {
      name: 'paymentDescription',
      alias: 'description',
      type: CtrlType.HIDDEN,
    },
    {
      name: 'value',
      label: 'Comissão',
      wrapClass: 'col-12 col-sm-12 col-md-6',
      disabled: true,
    },
  ],
  [
    {
      name: 'product',
      label: 'Produtos',
      wrapClass: 'col-12 col-sm-12',
    },
  ],
  [
    {
      name: 'description',
      label: 'Descrição',
      wrapClass: 'col-12 col-sm-12',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
      description: 'OBS: Essa descrição aparecerá no Portal Glampartners.',
      type: CtrlType.TEXTAREA,
    },
  ],
  [
    {
      name: 'mainVideo',
      label: 'Video principal',
      wrapClass: 'col-12 col-sm-12',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
      description:
        'OBS: Video principal que aparecerá no Challenge de Glamstar.',
      type: CtrlType.HIDDEN,
    },
  ],
  [
    {
      name: 'bannerMobile',
      label: 'Link do banner (MOBILE)',
      wrapClass: 'col-12 col-sm-6',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
      description:
        'OBS: Link do banner que aparecerá no Challenge de Glamstar no dispositivo mobile.',
      type: CtrlType.HIDDEN,
    },
    {
      name: 'bannerDesktop',
      label: 'Link do banner (DESKTOP)',
      wrapClass: 'col-12 col-sm-6',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
      description:
        'OBS: Link do banner que aparecerá no Challenge de Glamstar no desktop.',
      type: CtrlType.HIDDEN,
    },
  ],
  [
    {
      name: 'resume',
      label: 'Resumo',
      wrapClass: 'col-12 col-sm-12',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
      description: 'OBS: Esse resumo aparecerá no Challenge de Glamstar.',
      type: CtrlType.HIDDEN,
      custom: true,
    },
  ],
  [
    {
      name: 'rules',
      label: 'Regras',
      wrapClass: 'col-12 col-sm-12',
      required: true,
      requiredMessage: 'Este campo é obrigatório.',
      description: 'OBS: Essa regra aparecerá no Challenge de Glamstar.',
      type: CtrlType.HIDDEN,
      custom: true,
    },
  ],
  [
    {
      name: 'firstTutorialVideo',
      label: 'Video tutorial 1',
      wrapClass: 'col-12 col-sm-12',
      description:
        'OBS: Video de tutorial que aparecerá no Challenge de Glamstar.',
      type: CtrlType.HIDDEN,
    },
    {
      name: 'secondTutorialVideo',
      label: 'Video tutorial 2',
      wrapClass: 'col-12 col-sm-12',
      description:
        'OBS: Video de tutorial que aparecerá no Challenge de Glamstar.',
      type: CtrlType.HIDDEN,
    },
    {
      name: 'thirdTutorialVideo',
      label: 'Video tutorial 3',
      wrapClass: 'col-12 col-sm-12',
      description:
        'OBS: Video de tutorial que aparecerá no Challenge de Glamstar.',
      type: CtrlType.HIDDEN,
    },
  ],
];
